module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-500.woff2?eb89003999cea37e721a490d2d056e8d";